export default date => {
  const time = date.getTime(),
    unixTimeStamp = Math.floor(time / 1000)
  return unixTimeStamp
}
